import React from 'react';
import { NavLink } from 'react-router-dom';

const MenuItem = ({ codigoReferencia, filhos, id, menuAbertoId, menuPai, nome, nomeIcone = 'm-menu__link-bullet m-menu__link-bullet--dot', privilegios, toggleMenu, url, visivel }) => {
    const isOpen = id === menuAbertoId;

    const menus = filhos
        .filter((menu) => {
            return menu.visivel === 1;
        }).map(menu =>
            <li key={menu.id}>
                <MenuItem {...menu} nomeIcone="fa fa-circle icon-submenu" />
            </li>
        );


    return (
        <React.Fragment>
            {(filhos != null && filhos.length > 0 ?
                <React.Fragment>
                    <a onClick={() => toggleMenu(id)} data-toggle="collapse" className={`dropdown-toggle ${(isOpen ? 'abrir-menu' : '')} d-flex`} to="">
                        <i className={nomeIcone}></i>
                        <div className="uninter-class-convenio-menu-base-texto">
                            {nome}
                        </div>
                    </a>
                    <ul className={`collapse list-unstyled sub-menu ${(isOpen ? 'show' : '')}`}>
                        {menus}
                    </ul>
                </React.Fragment>
                :
                <NavLink to={`/${url}`} >
                    <i className={nomeIcone}></i>
                    <div className="uninter-class-convenio-menu-base-texto">
                        {nome}
                    </div>
                </NavLink>
            )}
        </React.Fragment>
    );
}

export default MenuItem;